"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Block = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Block"));

// Generated by script, don't edit it please.
var Block = (0, _createSvgIcon["default"])({
  as: _Block["default"],
  ariaLabel: 'block',
  category: 'action',
  displayName: 'Block'
});
var _default = Block;
exports["default"] = _default;
module.exports = exports.default;